import firebase from 'firebase/app';
import 'firebase/functions';
import { getPlatforms } from '@ionic/vue';

export default {
  async getAppPublicData() {
    return (await firebase.app().functions('asia-east2').httpsCallable('getAppPublicData')()).data;
  },
  async insertApplication(application: any) {
    application.devicePlatforms = getPlatforms().join(" , ");
    application.userAgent = window.navigator.userAgent;
    return (await firebase.app().functions('asia-east2').httpsCallable('insertApplication')(application)).data;
  },
  async updateApplication(applicationId, updatingObj = {}) {
    return (await firebase.app().functions('asia-east2').httpsCallable('updateApplication')({ applicationId, ...updatingObj })).data[0];
  },

  async createNewOrder(order: any) {
    order.devicePlatforms = getPlatforms().join(" , ");
    order.userAgent = window.navigator.userAgent;
    return (await firebase.app().functions('asia-east2').httpsCallable('createNewOrder')(order)).data;
  },
}